// MEGBESZÉLÉS-HELYSZÍNEK — a helyszín-kulcsok EGY forrása (szerződés + BFF + web közös).
//
// MIÉRT itt: a lista korábban kézi másolatként élt a szerkesztő-űrlapon, a naptár szín-táblájában és a levél-sablon
// címke-tükrében. A helyszín-szűrő a negyedik hely lett volna — egy új helyszín (pl. a keszthelyi irodák bontása)
// bármelyikből kimaradva csendes hiba: nem választható, nem szűrhető, vagy szürke a naptárban. A megjelenített
// címkék és a színek a saját rétegükben maradnak — azokat fal-teszt köti ide.
/** A helyszín-kulcsok a megjelenítési sorrendben (a legacy MeetingLocationEnum). */
export const MEETING_LOCATION_KEYS = [
    'meeting_room',
    'breakout_room',
    'silent_box_1',
    'silent_box_2',
    'dining_room',
    'keszthely_office',
    'other',
];
//# sourceMappingURL=meeting-locations.js.map